import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=fa7f531e&scoped=true&"
import script from "./SectionTitle.vue?vue&type=script&lang=js&"
export * from "./SectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7f531e",
  null
  
)

export default component.exports